// src/plugins/i18n.ts
import { createI18n } from 'vue-i18n'
import cs from '@/locales/cs.json'
import en from '@/locales/en.json'
import sk from '@/locales/sk.json'
import de from '@/locales/de.json'
import pl from '@/locales/pl.json'
import fi from '@/locales/fi.json'
import sv from '@/locales/sv.json'
import deCh from '@/locales/de-ch.json'
import da from '@/locales/da.json'

// --- Překlady ---
const messages = { cs, en, sk, de, pl, fi, sv, 'de-ch': deCh, da } as const

export type AppLocale = 'cs' | 'sk' | 'en' | 'de' | 'pl' | 'fi' | 'sv' | 'de-ch' | 'da'

// --- Pomocná funkce pro sjednocení kódů jazyků ---
function normalizeLocale(locale?: string): AppLocale {
  const code = (locale || '').toLowerCase()
  if (code.startsWith('cs')) return 'cs'
  if (code.startsWith('sk')) return 'sk'
  if (code === 'de-ch') return 'de-ch'
  if (code.startsWith('de')) return 'de'
  if (code.startsWith('en')) return 'en'
  if (code.startsWith('pl')) return 'pl'
  if (code.startsWith('fi')) return 'fi'
  if (code.startsWith('sv')) return 'sv'
  if (code.startsWith('da')) return 'da'
  return 'cs'
}

// --- Detekce výchozího jazyka (localStorage / prohlížeč) ---
const detectedLocale = normalizeLocale(
  localStorage.getItem('locale') || navigator.language
)

// --- Czech/Slovak plural rules (1 | 2-4 | 5+) ---
function slavicPlural(choice: number, choicesLength: number): number {
  if (choice === 1) return 1
  if (choice >= 2 && choice <= 4) return 2
  return choicesLength < 4 ? 2 : 3
}

// --- Vytvoření instance i18n ---
export const i18n = createI18n({
  legacy: false,           // používáš Composition API
  globalInjection: true,   // umožní volat $t() v šablonách
  locale: detectedLocale,  // detekce z localStorage / systému
  fallbackLocale: 'cs',    // záložní jazyk
  messages,
  pluralRules: {
    cs: slavicPlural,
    sk: slavicPlural,
    pl: slavicPlural,
  },
})

// --- Pomocné funkce (volitelné) ---
export function setLocale(locale: string) {
  const normalized = normalizeLocale(locale)
  i18n.global.locale.value = normalized
  localStorage.setItem('locale', normalized)
}

export function getCurrentLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale
}

export function t(key: string, args?: Record<string, unknown>) {
  return i18n.global.t(key, args ?? {})
}

// --- Default export pro kompatibilitu se starými importy ---
export default i18n
